// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3vs13","error":"Textarea_error__2lDxy","readonly":"Textarea_readonly__30yfq","disabled":"Textarea_disabled__2smeW"};